import { render, staticRenderFns } from "./AddChangeDeleteX.vue?vue&type=template&id=3cc42505&scoped=true"
import script from "./AddChangeDeleteX.vue?vue&type=script&lang=js"
export * from "./AddChangeDeleteX.vue?vue&type=script&lang=js"
import style0 from "./AddChangeDeleteX.vue?vue&type=style&index=0&id=3cc42505&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc42505",
  null
  
)

export default component.exports